export class TextLine {
  constructor(readonly startOffset: number, readonly endOffset: number) {}
}
